import { ContractStandingData } from '../types';
import { EHttpMethod, usePortalQuery } from './usePortalQuery';

export const useContractStandingData = (): { isLoading: boolean; standingData: ContractStandingData } => {
  const { data: standingData, isLoading } = usePortalQuery<ContractStandingData>(
    EHttpMethod.GET,
    'standing-data/contract',
    'get-contract-standing-data',
    true,
    undefined,
    undefined,
    undefined,
    false,
    600000, // ensure data is not stale for 10 minutes
    600000 // prevent data being garbage collected for 10 minutes
  );

  return {
    isLoading,
    standingData: {
      standingDataFeatures: standingData?.standingDataFeatures ?? [],
      standingDataFeatureAttributes: standingData?.standingDataFeatureAttributes ?? [],
      standingDataAttributeValues: standingData?.standingDataAttributeValues ?? [],
      standingDataSiteTypeList: standingData?.standingDataSiteTypeList ?? [],
      standingDataPremiumJobList: standingData?.standingDataPremiumJobList ?? [],
      standingDataServiceCodeList: standingData?.standingDataServiceCodeList ?? [],
      standingDataAssetOwnershipList: standingData?.standingDataAssetOwnershipList ?? [],
      standingDataContractTypeList: standingData?.standingDataContractTypeList ?? [],
      standingDataBillingTypeList: standingData?.standingDataBillingTypeList ?? [],
      standingDataEnergyManagementTypeList: standingData?.standingDataEnergyManagementTypeList ?? [],
      standingDataIndustryMpidList: standingData?.standingDataIndustryMpidList ?? [],
      standingDataStandardDaysList: standingData?.standingDataStandardDaysList ?? [],
      standingDataBillingScheduleList: standingData?.standingDataBillingScheduleList ?? [],
      standingDataServiceSubTypeMap: standingData?.standingDataServiceSubTypeMap ?? {}
    }
  };
};
